<ng-container
  *ngIf="{
    product: product$ | async,
  } as content"
>
  @if (!content.product?.discontinued) {
    <div class="container-contact-our-experts">
      <button type="button" class="btn btn-secondary w-100" (click)="openModalContactOurExperts()">
        <span class="material-symbols-outlined m-r-4"> call </span>

        {{ 'contactOurExperts.label' | cxTranslate }}
      </button>
    </div>
  }
</ng-container>
